import { render, staticRenderFns } from "./ResidentEdit.vue?vue&type=template&id=650f9849&scoped=true&lang=pug"
import script from "./ResidentEdit.vue?vue&type=script&lang=ts"
export * from "./ResidentEdit.vue?vue&type=script&lang=ts"
import style0 from "./ResidentEdit.vue?vue&type=style&index=0&id=650f9849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f9849",
  null
  
)

export default component.exports